import AssignedJourneyCard from 'modules/journey/card/cards/assigned/component';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = [
  'status',
  'booking_number',
  'logistics_operator_code',
  'reference_number',
  'seal_number',
];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { status, booking_number, logistics_operator_code, reference_number, seal_number } =
      props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      isFullyCancelled: status === 'CANCELLED',
      booking_number,
      logistics_operator_code,
      reference_number,
      seal_number,
    };
  }),
  withHandlers({
    onCardClick:
      ({ onClick, journeyId }) =>
      () => {
        onClick(journeyId);
      },
  })
);

export default enhance(AssignedJourneyCard);
